import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useCurrentTabInfo = (tabs: { value: string }[]) => {
  const location = useLocation();

  const initialPath = useMemo(() => {
    const pathname = location.pathname.split('/');
    const lastPath = pathname.pop();
    const tabsListValues = tabs.map((tab) => tab.value);

    return tabsListValues.includes(lastPath || '') ? pathname.join('/') : location.pathname;
  }, [location.pathname]);

  const currentTab = useMemo(() => {
    return location.pathname.slice(initialPath.length).split('/').pop();
  }, [initialPath, location.pathname]);

  return { initialPath, currentTab };
};